var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMapfre(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2277.3333 626.66669",
    height: 626.66669,
    width: 2277.3333,
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M 0,470 H 1708 V 0 H 0 Z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,626.66667)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18)",
    id: "g14"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(750.048,294.9426)",
    id: "g20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path22",
    style: {
      fill: "#ed1834",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C -25.529,0 -45.302,-7.759 -59.818,-23.777 -71.582,-8.009 -89.352,0 -113.129,0 c -21.274,0 -38.294,-7.008 -49.807,-20.523 v 17.27 h -35.54 v -125.143 h 37.543 v 81.593 c 7.258,9.761 20.022,14.767 37.792,14.767 25.78,0 37.794,-10.012 37.794,-32.037 v -64.323 h 37.543 v 81.593 c 7.257,9.761 20.022,14.767 37.792,14.767 25.78,0 37.794,-10.012 37.794,-32.037 v -64.323 h 37.543 v 64.573 C 65.325,-23.777 41.047,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(964.293,212.5992)",
    id: "g24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path26",
    style: {
      fill: "#ed1834",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -10.512,-11.262 -27.281,-17.269 -48.305,-17.269 -27.781,0 -44.301,12.764 -44.301,33.788 0,21.024 16.52,33.788 44.301,33.788 21.024,0 37.793,-6.007 48.305,-17.27 z m 2.003,61.82 c -13.516,12.765 -35.291,20.523 -58.067,20.523 -43.299,0 -74.085,-27.28 -74.085,-65.824 0,-38.544 30.786,-65.825 74.085,-65.825 22.776,0 44.551,7.759 58.067,20.524 v -17.27 h 35.54 V 79.09 H 2.003 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1360.9949,274.4197)",
    id: "g28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path30",
    style: {
      fill: "#ed1834",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 V 17.27 H -35.54 V -107.873 H 2.003 v 81.592 c 6.006,10.012 17.519,14.767 36.291,14.767 9.01,0 16.77,-0.75 24.027,-2.502 L 65.325,18.27 C 62.072,19.772 55.814,20.523 47.054,20.523 27.031,20.523 9.261,12.764 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1508.1631,267.4114)",
    id: "g32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path34",
    style: {
      fill: "#ed1834",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C 23.777,0 37.292,-8.259 39.795,-24.277 H -43.8 C -41.047,-7.258 -27.782,0 0,0 M 61.82,-62.32 C 47.554,-69.579 25.779,-74.084 6.257,-74.084 c -32.537,0 -47.554,7.759 -50.057,25.779 H 70.83 c 1.002,7.008 1.503,11.263 1.503,16.519 0,35.04 -29.534,59.317 -72.333,59.317 -50.057,0 -79.341,-24.027 -79.341,-65.575 0,-42.297 29.785,-66.074 83.346,-66.074 29.783,0 57.064,7.508 71.081,18.02 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1213.3267,290.438)",
    id: "g36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path38",
    style: {
      fill: "#ed1834",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 v -123.891 h 37.543 v 95.108 H 93.356 V 1.251 H 37.543 v 2.503 c 0,16.269 8.76,22.526 31.536,22.526 7.259,0 20.273,-1.252 35.04,-3.504 l 2.503,26.53 C 94.358,52.81 80.842,54.562 65.325,54.562 21.775,54.562 0,36.541 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1112.7119,195.3302)",
    id: "g40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path42",
    style: {
      fill: "#ed1834",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -21.024,0 -37.793,6.007 -48.304,17.269 v 33.037 c 10.511,11.263 27.28,17.27 48.304,17.27 27.782,0 44.3,-12.764 44.3,-33.788 C 44.3,12.764 27.782,0 0,0 m 7.76,99.612 c -22.777,0 -44.551,-7.758 -58.067,-20.523 v 17.27 h -35.54 V -70.33 h 37.543 v 58.817 c 13.014,-12.765 34.038,-20.523 56.064,-20.523 43.299,0 74.083,27.28 74.083,65.824 0,38.544 -30.784,65.824 -74.083,65.824"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(364.3585,288.1853)",
    id: "g44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path46",
    style: {
      fill: "#ed1834",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,31.536 -25.279,56.815 -57.065,56.815 -32.037,0 -57.315,-25.029 -57.315,-56.815 0,-29.534 16.018,-58.567 45.051,-82.343 l -1.001,-0.501 c -81.343,40.546 -116.883,54.312 -140.41,54.312 -16.769,0 -28.532,-11.764 -28.532,-28.283 0,-34.539 42.047,-68.077 85.347,-68.077 C -80.341,-124.892 0,-59.568 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(460.7186,259.6528)",
    id: "g48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path50",
    style: {
      fill: "#ed1834",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -27.031,0 -61.07,-16.268 -142.163,-68.077 38.795,-20.524 62.072,-28.282 85.098,-28.282 43.299,0 85.347,33.538 85.347,68.076 C 28.282,-11.763 16.519,0 0,0"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMapfre);
export default __webpack_public_path__ + "static/media/logo_mapfre.933ea1bf613509c135185fc8a5cbec62.svg";
export { ForwardRef as ReactComponent };